import * as React from 'react';
import {Switch, view} from '@sail/ui';

export const Disabled = () => {
  return (
    <view.div
      css={{
        layout: 'column',
        gap: 'medium',
      }}
    >
      <Switch label="This Switch is disabled." defaultChecked disabled />
    </view.div>
  );
};
